module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.ticketsWarning) ? _c('div', {
    staticClass: "tickets-warning",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h3', [_vm._v("注意事項")]), _c('h4', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("「團體票」 與 「團體潛水票」 將於 9/04 中午12:00 開賣，請密切注意")]), _vm._m(0), _c('div', {
    staticClass: "btn ghost-btn red",
    on: {
      "click": function($event) {
        _vm.ticketsWarning = !_vm.ticketsWarning
      }
    }
  }, [_vm._v("關閉")]), _c('p')]) : _vm._e(), _c('flowStep', {
    attrs: {
      "flow": _vm.flow
    }
  }), _vm._l((_vm.flow.steps), function(step, key) {
    return (_vm.flow.actived == key) ? _c('div', {
      staticClass: "step-title"
    }, [_c('div', {
      staticClass: "circle"
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(key))])]), _c('h1', [_vm._v(_vm._s(step))])]) : _vm._e()
  }), _c('div', {
    staticClass: "contents"
  }, [_c('router-view')], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("WirForce 官方販售 BYOC 門票不會額外收取報名服務費，欲報名者請以官方釋出的座位與消息為主。"), _c('br'), _vm._v("WirForce BYOC 進場門票採實名制登記，活動期間需驗證身分證件入場，若與他人協商座位導致當天無法進場，後果恕請自行負責。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5f680a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets.vue
// module id = 574
// module chunks = 1